<nav id="sidebar" *ngIf="isOpen" [@slideInOut]>
    <div class="sidebar_container">
        <input
            matInput
            type="text"
            placeholder="Search for any module..."
            [(ngModel)]="searchText"
            [matAutocomplete]="autoAuditor"
            #autocompleteTrigger="matAutocompleteTrigger"
            (keyup.enter)="showSuggestions(autocompleteTrigger)"
            (keyup)="handleKeyUp($event)"
        >
        <mat-autocomplete #autoAuditor="matAutocomplete">
            <mat-option
                [ngStyle]="{'pointer-events': isNotFountMsg() ? 'none' : 'all' }"
                *ngFor="let screen of filteredSections"
                [value]="screen.name"
                (click)="navigateFromSearch(screen)"
            >
                <ng-container *ngIf="screen.notFoundMsg; else: elseBlock">
                    <span style="pointer-events: none;">{{ screen.notFoundMsg }}</span>
                </ng-container>
                <ng-template #elseBlock>
                    <span>{{ screen.name }}</span>
                    <span style="font-weight: bolder;">{{ screen.moduleName | uppercase }}</span>
                </ng-template>
            </mat-option>
        </mat-autocomplete>
        <div class="Subpart_body">
            <div class="subpart_header" (click)="toggleSection('isEmployeeExpanded')">
                <div class="">
                    <span class="material-symbols-outlined icon-box">person </span>
                </div>
                <div class=""> Employee </div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isEmployeeExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isEmployeeExpanded">
                <ul class="menu">
                    <li class="menu-item" *ngIf="hideMenu.dashboard" title="My Dashboard">
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Dashboard']"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="dismissSidebar()"
                        >My Dashboard</a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="showemployeeimpersonation"
                        title="Employee Impersonation"
                    >
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Dashboard/Employee Impersonation']"
                            (click)="navigateTo('Home/Dashboard/Employee Impersonation')"
                            
                        >Employee Impersonation</a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Employee Skill Repository"
                    >
                        <a routerLinkActive="active" [routerLink]="['/Home/Skill Repository']"
                            (click)="dismissSidebar()">
                            Employee Skill Repository
                        </a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.employeeWithoutCompetency"
                        title="Employee Competency Assignment"
                    >
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Missing-mandatory-fields']"
                            (click)="dismissSidebar()"
                        >
                            Employee Competency Assignment
                        </a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.dashboard">
                        <div class="emp_career_item fw-600 employee_carrer">
                            Employee Career
                        </div>
                        <div class="employee_carrer_body">
                            <ul class="submenu">
                                <li class="submenu-item" title="Career Path">
                                    <a
                                        [routerLink]="['/Home/employee-career/employee-Career-path']"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="navigateTo('Home/employee-career/employee-Career-path')"
                                    >Career Path</a>
                                </li>
                                <li class="submenu-item" title="Career Program">
                                    <a
                                        [routerLink]="['Home/employee-career/employee-Career-program']"
                                        routerLinkActive="active"
                                        (click)="navigateTo('Home/employee-career/employee-Career-program')"
                                    >Career Program</a>
                                </li>
                                <li class="submenu-item" title="Program Catalogue">
                                    <a
                                        [routerLink]="['/Home/employee-career/program-catalogue']"
                                        [class.active]="isActiveProgramCatalogueLink()"
                                        (click)="programCatalogueNavigate()"
                                    >Program Catalogue</a>
                                </li>
                                <li
                                    class="submenu-item"
                                    *ngIf="isEmpCareerManager || accessForAddPrograms"
                                    title="Add Programs"
                                >
                                    <a
                                        [routerLink]="['/Home/employee-career/add-programs']"
                                        routerLinkActive="active"
                                        (click)="navigateTo('Home/employee-career/add-programs')"
                                    >Add Programs</a>
                                </li>
                                <li class="submenu-item">
                                    <div
                                        class="emp_career_item fw-600 employee_carrer"
                                    >
                                        Career Request
                                    </div>
                                    <div class="employee_carrer_body">
                                        <ul class="submenu">
                                            <li class="submenu-item" title="My Requests">
                                                <a
                                                    [routerLink]="['/Home/employee-career/employee-Career-request/my-requests']"
                                                    routerLinkActive="active"
                                                    (click)="navigateTo('/Home/employee-career/employee-Career-request/my-requests')"
                                                >My Requests</a>
                                            </li>
                                            <li
                                                *ngIf="isEmpCareerManager"
                                                class="submenu-item"
                                                title="Team Requests"
                                            >
                                                <a
                                                    [routerLink]="['/Home/employee-career/employee-Career-request/team-requests']"
                                                    routerLinkActive="active"
                                                    (click)="navigateTo('Home/employee-career/employee-Career-request/team-requests')"
                                                >Team Requests</a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="Subpart_body executive_body" *ngIf="hideMenu.executive">
            <div class="subpart_header" (click)="toggleSection('isExecutiveExpanded')">
                <div class="">
                    <span class="material-symbols-outlined icon-box">rule_settings </span>
                </div>
                <div class="">Executive</div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isExecutiveExpanded ? 'KEYBOARD_ARROW_DOWN' : 'KEYBOARD_ARROW_UP' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isExecutiveExpanded">
                <ul class="menu">
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Executive Dashboard - 2023"
                    >
                        <a
                            routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=76e04c44-98ba-4282-a009-a71b65409b8b&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')"
                        >
                            Executive Dashboard - 2023
                        </a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Executive Dashboard - 2024"
                    >
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/groups/me/reports/aecdd6f6-f055-4ef1-8f93-d251ffba5d87/ReportSectionb4855d102fdd1dfea32e?experience=power-bi')"
                        >
                            Executive Dashboard - 2024
                        </a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Executive Dashboard - 2023 & 2024"
                    >
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/groups/me/reports/f48ee236-24bd-497d-ae1c-e23d5487a92f/ReportSection9dbc46faa1dc574d04e2?experience=power-bi')"
                        >
                            Executive Dashboard - 2023 & 2024
                        </a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.skillRepository" title="RMG">
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=b956e1bb-20f1-4f52-a459-1539674a0d68&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')"
                        >
                            RMG
                        </a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.skillRepository" title="Sales">
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=b8a3449f-7d47-4b60-9c64-ec0a863987c5&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')"
                        >
                            Sales
                        </a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.skillRepository" title="Pre-sales">
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=98047a43-c119-4370-b99e-2400653a462e&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')"
                        >
                            Pre-sales
                        </a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Customer 360 Portal"
                    >
                        <a routerLinkActive="active" [routerLink]="['/Home/Customer360']">
                            Customer 360 Portal
                        </a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.skillRepository" title="GSD Review">
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=cce16eca-a81e-4a7f-9162-996823a113fc&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')"
                        >
                            GsdReview
                        </a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.skillRepository"
                        title="Global Demand Dashboard"
                    >
                        <a routerLinkActive="active"
                            onclick="window.open('https://app.powerbi.com/groups/me/reports/287abbd2-6124-4746-b8d6-ae99fa5bf21e/ReportSectiondb054d34dd265e40dd85?experience=power-bi')"
                        >
                            Global Demand Dashboard
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="Subpart_body" *ngIf="hideMenu.sales && accessForKMS">
            <div class="subpart_header" (click)="toggleSection('isKmsExpanded')">
                <div class=""><span class="material-symbols-outlined icon-box">group </span></div>
                <div class="">
                    KMS
                </div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isKmsExpanded ? 'KEYBOARD_ARROW_DOWN' : 'KEYBOARD_ARROW_UP' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isKmsExpanded">
                <ul class="menu">
                    <li class="menu-item" *ngIf="!hideMenu.salesdashboard" title="KMS Dashboard">
                        <a
                            [class.active]="isActiveKMSLink()"
                            [routerLink]="['/Home/KMSPortal']"
                            (click)="navigateTo('Home/KMSPortal')"
                        >Dashboard</a>
                    </li>
                    <li class="menu-item" *ngIf="!hideMenu.projectcontent" title="Project Content">
                        <a
                            [routerLink]="['Home/KMSPortal/Project Content']"
                            (click)="navigateTo('Home/KMSPortal/Project Content')"
                            routerLinkActive="active"
                        >Project Content</a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="!hideMenu.pendingapprovals"
                        title="Pending Approvals"
                    >
                        <a
                            [routerLink]="['Home/KMSPortal/Pending Approvals']"
                            (click)="navigateTo('Home/KMSPortal/Pending Approvals')"
                            routerLinkActive="active"
                        >Pending Approvals</a>
                    </li>
                    <li class="menu-item" *ngIf="!hideMenu.users" title="Users">
                        <a
                            [routerLink]="['/users/userlist']"
                            (click)="navigateTo('users/userlist')"
                            routerLinkActive="active"
                        >Users</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="Subpart_body" *ngIf="hideMenu.portal">
            <div class="subpart_header" (click)="toggleSection('isPortalExpanded')">
                <div class="">
                    <span class="material-symbols-outlined icon-box">captive_portal </span>
                </div>
                <div class="">Portal</div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isPortalExpanded ? 'KEYBOARD_ARROW_DOWN' : 'KEYBOARD_ARROW_UP' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isPortalExpanded">
                <ul class="menu">
                    <li class="menu-item" *ngIf="hideMenu.competency" title="CMF Portal">
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/CMF Portal']"
                            (click)="navigateTo('/Home/CMF Portal')"
                        >CMF Portal</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.dmdPortal" title="DMD Portal">
                        <a
                            onclick="window.open('https://dmd.innovasolutions.com', '_blank')"
                            routerLinkActive="active"
                        >DMD Portal</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.ppmPortal" title="PPM Portal">
                        <a
                            onclick="window.open('https://epas.innovasolutions.com/')"
                            routerLinkActive="active"
                        >PPM Portal</a>
                    </li>
                </ul>
            </div>
        </div>

        <div
            class="Subpart_body"
            *ngIf="hideMenu.compliance || hideMenu.timeSheet || timesheetview"
        >
            <div class="subpart_header" (click)="toggleSection('isGovernanceExpanded')">
                <div class="">
                    <span
                        style="transform: rotate(270deg);"
                        class="material-symbols-outlined icon-box"
                    >captive_portal </span>
                </div>
                <div class="">Governance</div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isGovernanceExpanded ? 'KEYBOARD_ARROW_DOWN' : 'KEYBOARD_ARROW_UP' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isGovernanceExpanded">
                <ul class="menu">
                    <li class="menu-item" *ngIf="hideMenu.compliance">
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Compliance']"
                            (click)="navigateTo('/Home/Compliance')"
                            title="Compliance"
                        >Compliance</a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.timesheet || timesheetview"
                        title="Timesheet Management"
                    >
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Timesheet Management']"
                            (click)="navigateTo('/Home/Timesheet Management')"
                        >Timesheet Management</a>
                    </li>
                </ul>
            </div>
        </div>

        <div
            class="Subpart_body"
            *ngIf="
                hideMenu.proposals ||
                hideMenu.templates ||
                hideMenu.salaryRangeCalcualtor ||
                hideMenu.techstack ||
                hideMenu.poc
            "
        >
            <div class="subpart_header" (click)="toggleSection('isOthersExpanded')">
                <div class="">
                    <span class="material-symbols-outlined icon-box">database </span>
                </div>
                <div class="">Others</div>
                <span class="material-symbols-outlined toggle-icon">
                    {{ isOthersExpanded ? 'KEYBOARD_ARROW_DOWN' : 'KEYBOARD_ARROW_UP' }}
                </span>
            </div>
            <div class="subpart_container" *ngIf="isOthersExpanded">
                <ul class="menu">
                    <li class="menu-item" *ngIf="hideMenu.proposals" title="Proposal Repository">
                        <a
                            [routerLink]="['/Home/Proposal Repository']"
                            (click)="navigateTo('/Home/Proposal Repository')"
                            routerLinkActive="active"
                        >Proposal Repository</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.templates" title="Artifactory Repository">
                        <a
                            [routerLink]="['/Home/Artifactory Repository']"
                            (click)="navigateTo('/Home/Artifactory Repository')"
                            [class.active]="isActiveArtifactoryLink()"
                        >Artifactory Repository</a>
                    </li>
                    <li
                        class="menu-item"
                        *ngIf="hideMenu.salaryRangeCalcualtor"
                        title="Salary Range Calculator"
                    >
                        <a
                            routerLinkActive="active"
                            (click)="salaryRangeNavigate()"
                        >Salary Range Calculator</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.techstack" title="Project Tech Stack">
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/ProjectTechStack']"
                            (click)="dismissSidebar()"
                        >Project Tech Stack</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.poc" title="Proof of Concepts">
                        <a
                            routerLinkActive="active"
                            [routerLink]="['/Home/Proof Of Concepts']"
                            (click)="dismissSidebar()"
                        >Proof of Concepts</a>
                    </li>
                    <li class="menu-item" *ngIf="hideMenu.dashboard">
                        <div
                            class="emp_career_item fw-600 employee_carrer"
                        >
                            Audits
                        </div>
                        <div class="Audits_body">
                            <ul class="submenu">
                                <li class="submenu-item" title="Audits">
                                    <a
                                        [routerLink]="['/Home/Audit']"
                                        routerLinkActive="active"
                                        (click)="dismissSidebar()"
                                    >Audits</a>
                                </li>
                                <li class="submenu-item" title="Master Questions">
                                    <a
                                        [routerLink]="['Home/MasterQuestion']"
                                        routerLinkActive="active"
                                        (click)="dismissSidebar()"
                                    >Master Questions</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>